import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import PageHero from '../components/PageHero';
import AboutBadge from '../components/AboutBadge';

const family = [
  ['Marcos Robert Duran', 'https://www.facebook.com/marcosrobertduran'],
  ['Heather Duran', 'https://www.facebook.com/heather.duran.96'],
  ['Aerial Duran', 'https://www.facebook.com/aerial.duran.1']
];

function About() {
  return (
    <>
      <PageHero
        eyebrow="Our story"
        title="A family of creative professionals."
        text="Duran Media Solutions is a family of creative, experienced professionals who have devoted more than 30 years to the art of mass media communications."
      />
      <section className="about-story">
        <div className="about-image">
          <motion.img
            src="https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?auto=format&fit=crop&w=1400&q=85"
            alt="A media production team collaborating in a professional studio"
            initial={{opacity: 0}}
            whileInView={{opacity: 1}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
          />
          <AboutBadge />
        </div>
        <div className="about-copy">
          <span className="section-tag">Built on service</span>
          <h2>
            Unparalleled service. <br />
            <em>Total satisfaction.</em>
          </h2>
          <p>
            Duran Media Solutions is a family of creative, experienced
            professionals with more than three decades dedicated to the art of
            mass media communications. Every project we take on is shaped by
            that depth of experience and a genuine passion for the craft.
          </p>
          <p>
            We take pride in delivering exceptional customer service and in
            ensuring every client is completely satisfied with the result.
          </p>
          <p>
            To get to know the people behind the work, we invite you to visit
            our personal social media pages.
          </p>
          <ul className="link-list">
            {family.map(([name, href]) => (
              <li key={href}>
                <a href={href} target="_blank" rel="noopener noreferrer">
                  <span>{name}</span>
                  <SafeIcon name="ArrowUpRight" aria-hidden="true" focusable="false" />
                </a>
              </li>
            ))}
          </ul>
          <Link to="/contact" className="primary-button">
            Meet your media partner
            <SafeIcon name="ArrowRight" aria-hidden="true" focusable="false" />
          </Link>
        </div>
      </section>
    </>
  );
}

export default About;